/**
 * Reducer adding values to person, eather an employy of Company or contact person for apartment.
 *
 * @author Elsa <elsa@vertics.co>
 *
 * @copyright Vertics Co 2019
 */
import {
	personTypes as types,
	loginTypes,
	companyTypes,
	workInAddressTypes
} from '../actions/types'

const initialState = {
	name: '',
	phoneNumber: '',
	email: '',
	persons: [],
	personsId: [],
	idToRemove: ''
}

export const personReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.changeField:
			return {
				...state,
				[action.name]: action.value
			}

		case types.create:
			return {
				...state
			}

		case types.createSuccess:
			return {
				...state,
				name: '',
				phoneNumber: '',
				email: '',
				persons: [...state.persons, action.payload.data],
				personsId: [...state.personsId, action.payload.data.id]
			}

		case types.createFail:
			return state

		case types.delete:
			return {
				...state,
				idToRemove: action.id
			}

		case types.deleteSuccess:
			const modifiedPersons = state.persons.filter(
				person => person.id !== state.idToRemove
			)
			const modifiedPersonsId = state.personsId.filter(
				personId => personId !== state.idToRemove
			)
			return {
				...state,
				persons: modifiedPersons,
				personsId: modifiedPersonsId,
				idToRemove: ''
			}
		case workInAddressTypes.updateReducerForFinishEditing:
		case companyTypes.createSuccess:
		case workInAddressTypes.createSuccess:
			return initialState

		case loginTypes.logout:
			return initialState

		default:
			return state
	}
}

export const personSelectors = {
	getField: (state = initialState, field) => state[field]
}
